import { Action } from '../../actions/core/action';
import { UserResponse } from '../user/user.model';

export class AuthGrantedAction implements Action {
  constructor(public user: UserResponse, public type: AuthType) {}
}

export class AuthRevokedAction implements Action {}

export enum AuthType {
  PASSWORDLOGIN,
  MOBILECONNECT
}



// WEBPACK FOOTER //
// src/app/common/services/auth/auth.action.ts